<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="standardpage reports invoices border-none">
      <!-- {{ id }}
      {{ disabled }} -->
      <div class="availtable datatable">
        <b-card class="w-100pct">
          <b-card-header class="py-1 mb-2">
            <i :class="options.icon" class="text-primary mr-1"></i>
            {{ item.ledger }}, {{ item.entry }}
            <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
          </b-card-header>
          <b-card-body class="py-0">
            <b-row>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Type" label-for="type" label-cols="12">
                  <b-input-group>
                    <treeselect instanceId="type" type="number" v-model="item.ledger" :clearable="true"
                      :options="type_options"></treeselect>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Entry" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.entry" :debounce="options.debounce" placeholder="Entry"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!item.entry" @click="item.entry = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Line" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.line" :debounce="options.debounce" placeholder="Line"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!item.line" @click="item.line = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Transaction" label-for="transtype" label-cols="12">
                  <b-input-group>
                    <treeselect instanceId="transtype" type="number" v-model="item.transtype" :clearable="true"
                      :options="transaction_options"></treeselect>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="N/L Accounts" label-size="sm">
                  <treeselect instanceId="nlcode" type="number" v-model="item.nlcode" :clearable="true"
                    :options="nlcode_options"></treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Transaction Date" label-size="sm">
                  <b-input-group>
                    <b-form-datepicker size="sm" v-model="item.dateref" label-help hide-header locale="en-GB"
                      placeholder="From" :debounce="options.debounce" :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"></b-form-datepicker>

                    <b-input-group-append>
                      <b-button size="sm" squared variant="outline-secondary" :disabled="!item.dateref"
                        @click="item.dateref = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Depart Date" label-size="sm">
                  <b-input-group>
                    <b-form-datepicker size="sm" v-model="item.datedepart" label-help hide-header locale="en-GB"
                      placeholder="From" :debounce="options.debounce" :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"></b-form-datepicker>

                    <b-input-group-append>
                      <b-button size="sm" squared variant="outline-secondary" :disabled="!item.datedepart"
                        @click="item.datedepart = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Ref" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.ref" :debounce="options.debounce" placeholder="Ref"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!item.ref" @click="item.ref = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Credit" label-size="sm">
                  <b-input-group>
                    <b-form-input
                      v-model="item.credit"
                      :debounce="options.debounce"
                      placeholder="Credit"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!item.credit"
                        @click="item.credit = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                  <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..." v-model="item.blac"
                    :clearable="true" :async="true" :load-options="treeselect_loadBLAC" :show-count="true"
                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                  <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="item.slac"
                    :clearable="true" :async="true" :load-options="treeselect_loadSLAC" :show-count="true"
                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Sales Group" label-for="salesgroup" label-cols="12">
                  <treeselect placeholder="Select sales group..." searchPromptText="Type at least 3 chars..."
                    v-model="item.salesgroup" :clearable="true" :async="true" :load-options="treeselect_loadSalesgroups"
                    :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                    search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect placeholder="Select event..." v-model="item.eventcode" :clearable="true" :async="true"
                    :load-options="treeselect_loadEvent" searchPromptText="Type at least 4 chars..." :show-count="true" :flatten-search-results="true"
                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Age" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.age" :debounce="options.debounce" placeholder="Age"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!item.age" @click="item.age = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Period" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.period" :debounce="options.debounce" placeholder="Period"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!item.period" @click="item.period = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Amount" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.amount" :debounce="options.debounce" placeholder="Amount"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!item.amount" @click="item.amount = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Batch" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.batch" :debounce="options.debounce" placeholder="Batch"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!item.batch" @click="item.batch = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="BK Form" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.bkform" :debounce="options.debounce" placeholder="BK Form"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!item.bkform" @click="item.bkform = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Status" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.status" :debounce="options.debounce" placeholder="Status"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!item.status" @click="item.status = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Prog" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.prog" :debounce="options.debounce" placeholder="Prog"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!item.prog" @click="item.prog = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Autosource" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.autosource" :debounce="options.debounce"
                      placeholder="Autosource"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!item.autosource"
                        @click="item.autosource = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="AP" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.ap" :debounce="options.debounce" placeholder="AP"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!item.ap" @click="item.ap = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Revent" label-size="sm">
                  <treeselect placeholder="Select revent..." searchPromptText="Type at least 3 chars..."
                    v-model="item.revent" :clearable="true" :async="true" :load-options="treeselect_loadEvent"
                    :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                    :disabled="readonly" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Travel AP" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.travelap" :debounce="options.debounce"
                      placeholder="Travel AP"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!item.travelap"
                        @click="item.travelap = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Linked Entry" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.linkedentry" :debounce="options.debounce"
                      placeholder="Linked Entry"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!item.linkedentry"
                        @click="item.linkedentry = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Year" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="item.year" :debounce="options.debounce" placeholder="Year"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!item.year" @click="item.year = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-row>
                  <b-col>
                    <b-form-group label-cols="12" label="Future?" label-size="sm">
                      <b-form-radio-group id="future" v-model="item.future" :options="[
                        { text: 'Yes', value: true },
                        { text: 'No', value: false },
                      ]" buttons button-variant="outline-success" size="sm"
                        name="radio-btn-outline"></b-form-radio-group>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label-cols="12" label="Cleared?" label-size="sm">
                      <b-form-radio-group id="cleared" v-model="item.cleared" :options="[
                        { text: 'Yes', value: true },
                        { text: 'No', value: false },
                      ]" buttons button-variant="outline-success" size="sm"
                        name="radio-btn-outline"></b-form-radio-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Reversed?" label-size="sm">
                  <b-form-radio-group id="reversed" v-model="item.reversed" :options="[
                    { text: 'Yes', value: true },
                    { text: 'No', value: false },
                  ]" buttons button-variant="outline-success" size="sm"
                    name="radio-btn-outline"></b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Comment" label-for="comment" label-cols="12">
                  <b-form-textarea id="data" v-model="item.comment" placeholder="Comment" rows="2" class="smalltextarea"
                    :disabled="readonly"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="idselected">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Created At" label-for="created_at" label-cols="12">
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-form-datepicker size="sm" v-model="item.created_at" button-only label-help="" locale="en-GB"
                        :disabled="true"></b-form-datepicker>
                    </b-input-group-prepend>
                    <b-form-input size="sm" id="date" v-model="item.created_at" type="text" placeholder="YYYY-MM-DD"
                      autocomplete="off" :disabled="true"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="item.created_at = null" :disabled="true">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Created By" label-for="created_by" label-cols="12">
                  <b-input-group>
                    <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                      :disabled="true"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="item.created_by = ''" :disabled="true">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                  <b-input-group>
                    <b-input-group-prepend>
                      <b-form-datepicker size="sm" v-model="item.updated_at" button-only label-help="" locale="en-GB"
                        :disabled="true"></b-form-datepicker>
                    </b-input-group-prepend>
                    <b-form-input size="sm" id="date" v-model="item.updated_at" type="text" placeholder="YYYY-MM-DD"
                      autocomplete="off" :disabled="true"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="item.updated_at = null" :disabled="true">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                  <b-input-group>
                    <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                      :disabled="true"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="item.updated_by = ''" :disabled="true">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>

          <b-card-footer class="nopadding mt-2">
            <b-row no-gutters>
              <b-col cols="auto" class="text-left">
                <b-button squared size="sm" variant="primary" @click="saveit()">
                  <i class="fa fa-check"></i>
                  Save It
                </b-button>
              </b-col>
              <b-col class="text-left ml-2 mt-1">
                <div v-if="busy">
                  <i class="fa fa-spinner fa-spin text-primary"></i>
                </div>
                <div v-else>
                  <span v-html="message"></span>
                </div>
              </b-col>
              <b-col class="text-right" cols="8">
                <b-button squared size="sm" variant="secondary" @click="$emit('discard')">
                  <i class="fa fa-chevron-left pr-1"></i>
                  Back
                </b-button>
              </b-col>
            </b-row>
          </b-card-footer>

          <b-card-footer class="mt-2 ml-1">
            <b-row>

              <b-col class="text-right" cols="8">

                <b-button squared size="sm" variant="primary" @click="saveit()">
                  <i class="fa fa-check"></i>
                  Save It
                </b-button>
              </b-col>
            </b-row>
          </b-card-footer>
        </b-card>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "NLTransactionEdit",
  data() {
    return {
      busy: false,
      type_options: [
        { id: "BL", label: "Bought Ledger | BL" },
        { id: "SL", label: "Sales Ledger | SL" },
      ],
      transaction_options: [
        { id: "BLP", label: "Bought Ledger Payment | BLP" },
        { id: "SLP", label: "Sales Ledger Payment | SLP" },
        { id: "GLJ", label: "Nominal Ledger | GLJ" },
        { id: "INV", label: "Invoice | INV" },
        { id: "CRD", label: "Credit | CRD" },
      ],
      nlcode_options: [],
      item: {},
      options: {
        title: "Edit N/L Transaction",
        icon: "fa fa-balance-scale",
        debounce: 500,
      },
    };
  },
  computed: {
    readonly() {
      return true;
    },
  },
  methods: {
    async loadDDL() {
      //this.busy = true;

      try {
        const response = await this.$apollo.query({
          query: gql`
            query nlcodes {
              nlcodes {
                id
                label
              }
            }
          `,
        });
        this.nlcode_options = response.data.nlcodes;
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async load() {
      let variables = {
        id: this.idselected,
      };
      console.log("variables", variables);
      this.busy = true;

      try {
        const response = await this.$apollo.query({
          query: gql`
            query NLTransactions($id: String) {
              NLTransactions(id: $id) {
                id
                credit
                salesgroup
                eventcode
                nlcode
                entry
                line
                period
                dateref
                datedepart
                amount
                ref
                comment
                transtype
                batch
                age
                blac
                slac
                future
                bkform
                cleared
                status
                prog
                autosource
                ap
                revent
                travelap
                linkedentry
                reversed
                ledger
                year
                 created_at
                created_by
                updated_at
                updated_by
              }
            }
          `,
          variables,
        });

        console.log(response.data.NLTransactions);
        this.item = response.data.NLTransactions[0];

        this.item.dateref = this.$helpers.datefield(this.item.dateref);
        this.item.datedepart = this.$helpers.datefield(this.item.datedepart);
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async saveit() {
      this.busy = true;

      let row = this.cleanit(this.item);
      delete row.credit;

      let variables = { rows: [row] };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation NLTransactions_save(
              $rows: [NLTransaction_input]
              $dateformat: String
            ) {
              NLTransactions_save(rows: $rows, dateformat: $dateformat) {
                id
              }
            }
          `,
          variables,
        });
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }
      this.busy = false;
    },
  },
};
</script>


